angular.module('lsnBase.deprecated.models')
  .factory('IdentityDocumentModelConstants', ['LsnIdentityDocumentModelConstants', function(LsnIdentityDocumentModelConstants) {
    return LsnIdentityDocumentModelConstants;
  }])
  .factory('IdentityDocumentModel', ['LsnIdentityDocumentModelV1',
    function(LsnIdentityDocumentModelV1) {
      return LsnIdentityDocumentModelV1;
    }
  ]);